import { SvgIcon, SvgIconProps, Theme } from '@mui/material';
import { forwardRef } from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { SxProps } from '@mui/system';

export interface FontAwesomeSvgIconProps extends SvgIconProps {
    icon: IconDefinition;
}

type FontAwesomeSvgProps = SvgIconProps;

export const MediaUploadIcon = ({
    sx,
    ...rest
}: {
    sx?: SxProps;
}): JSX.Element => {
    return (
        <SvgIcon
            width="23"
            height="18"
            viewBox="0 0 23 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={sx}
            {...rest}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.63281 4.61719C10.0547 4.01953 11.0391 4.01953 11.4258 4.61719L12.2758 5.90661C11.9634 6.10586 11.6679 6.32922 11.3919 6.57405L10.5117 5.25L7.55859 9.82031C7.45312 9.96094 7.27734 10.0664 7.10156 10.0664C6.92578 10.1016 6.75 9.99609 6.64453 9.82031L5.58984 8.37891L3.375 11.4375H9.04503C9.03848 11.5617 9.03516 11.6867 9.03516 11.8125C9.03516 12.0659 9.04862 12.3161 9.07486 12.5625H3.33984C2.95312 12.5625 2.56641 12.3516 2.39062 12C2.21484 11.6133 2.25 11.1914 2.46094 10.875L4.74609 7.71094C5.13281 7.14844 6.08203 7.14844 6.50391 7.71094L7.06641 8.51953L9.63281 4.61719ZM9.70879 14.8125H2.28516C1.65234 14.8125 1.16016 14.3203 1.16016 13.6875V2.4375C1.16016 1.83984 1.65234 1.3125 2.28516 1.3125H15.7852C16.3828 1.3125 16.9102 1.83984 16.9102 2.4375V4.86666C17.2834 4.91319 17.6474 4.98911 18 5.09202V2.4375C18 1.20703 17.0156 0.1875 15.75 0.1875H2.25C1.01953 0.1875 0 1.20703 0 2.4375V13.6875C0 14.9531 1.01953 15.9375 2.25 15.9375H10.3791C10.1222 15.5859 9.89738 15.2095 9.70879 14.8125ZM6.78516 4.125C6.78516 5.07422 6.01172 5.8125 5.09766 5.8125C4.14844 5.8125 3.41016 5.07422 3.41016 4.125C3.41016 3.21094 4.14844 2.4375 5.09766 2.4375C6.01172 2.4375 6.78516 3.21094 6.78516 4.125ZM5.625 4.125C5.625 3.84375 5.37891 3.5625 5.09766 3.5625C4.78125 3.5625 4.53516 3.84375 4.53516 4.125C4.53516 4.44141 4.78125 4.6875 5.09766 4.6875C5.37891 4.6875 5.625 4.44141 5.625 4.125Z"
                fill="black"
                fillOpacity="0.54"
            />
            <path
                d="M16.4336 8.625C16.3398 8.50781 16.1758 8.4375 16.0352 8.4375C15.8711 8.4375 15.707 8.50781 15.6133 8.625L13.1758 11.25C12.9648 11.4844 12.9648 11.8359 13.1992 12.0469C13.4336 12.2578 13.7852 12.2578 13.9961 12.0234L15.4727 10.4531V14.4375C15.4727 14.7656 15.707 15 16.0352 15C16.3398 15 16.5977 14.7656 16.5977 14.4375V10.4531L18.0508 12.0234C18.2617 12.2578 18.6133 12.2578 18.8477 12.0469C19.082 11.8359 19.082 11.4844 18.8711 11.25L16.4336 8.625ZM16.0352 5.8125C12.707 5.8125 10.0352 8.50781 10.0352 11.8125C10.0352 15.1406 12.707 17.8125 16.0352 17.8125C19.3398 17.8125 22.0352 15.1406 22.0352 11.8125C22.0352 8.50781 19.3398 5.8125 16.0352 5.8125ZM16.0352 16.6875C13.3398 16.6875 11.1602 14.5078 11.1602 11.8125C11.1602 9.14062 13.3398 6.9375 16.0352 6.9375C18.707 6.9375 20.9102 9.14062 20.9102 11.8125C20.9102 14.5078 18.707 16.6875 16.0352 16.6875Z"
                fill="black"
                fillOpacity="0.54"
            />
        </SvgIcon>
    );
};

export const FASolidStarIcon = forwardRef<SVGSVGElement, FontAwesomeSvgProps>(
    // eslint-disable-next-line react/prop-types
    ({ sx }, ref) => {
        return (
            <SvgIcon ref={ref} sx={sx} viewBox="0 0 576 512">
                <path d="M316.7 17.8l65.43 132.4l146.4 21.29c26.27 3.796 36.79 36.09 17.75 54.59l-105.9 102.1l25.05 145.5c4.508 26.31-23.23 45.9-46.49 33.7L288 439.6l-130.9 68.7C133.8 520.5 106.1 500.9 110.6 474.6l25.05-145.5L29.72 226.1c-19.03-18.5-8.516-50.79 17.75-54.59l146.4-21.29l65.43-132.4C271.1-6.083 305-5.786 316.7 17.8z" />
            </SvgIcon>
        );
    }
);
FASolidStarIcon.displayName = 'FASolidStarIcon';

export const FASolidHalfStarIcon = forwardRef<
    SVGSVGElement,
    { sx?: SxProps<Theme>; secondaryColor?: string }
>(
    // eslint-disable-next-line react/prop-types
    ({ sx, secondaryColor }, ref) => {
        return (
            <SvgIcon ref={ref} sx={sx} viewBox="0 0 576 512">
                <path
                    style={
                        secondaryColor
                            ? { color: secondaryColor }
                            : { opacity: 0.4 }
                    }
                    d="M287.1 .0049C288 .0049 287.1 .0049 287.1 .0049c11.39 0 22.87 5.894 28.75 17.8l65.43 132.4l146.4 21.29c26.27 3.797 36.79 36.09 17.75 54.59l-105.9 102.1l25.05 145.5C468.1 495.3 452.4 512 433.8 512c-4.932 0-10.01-1.172-14.88-3.75L288 439.6L287.1 .0049z"
                />
                <path d="M288 439.6l-130.9 68.7C152.2 510.8 147.1 512 142.2 512c-18.59 0-35.17-16.66-31.61-37.45l25.04-145.5L29.72 226.1C10.68 207.6 21.2 175.3 47.47 171.5l146.4-21.29l65.43-132.4c5.883-11.91 17.33-17.8 28.73-17.8c.0234 0-.0234 0 0 0L288 439.6z" />
            </SvgIcon>
        );
    }
);
FASolidHalfStarIcon.displayName = 'FASolidHalfStarIcon';

export const Icon = forwardRef<SVGSVGElement, FontAwesomeSvgIconProps>(
    // eslint-disable-next-line react/prop-types
    ({ sx, icon, ...rest }, ref) => {
        const {
            // eslint-disable-next-line react/prop-types
            icon: [width, height, , , svgPathData],
        } = icon;

        return (
            <SvgIcon
                sx={sx}
                ref={ref}
                {...rest}
                viewBox={`0 0 ${width} ${height}`}
            >
                {typeof svgPathData === 'string' ? (
                    <path d={svgPathData} />
                ) : (
                    /**
                     * A multi-path Font Awesome icon seems to imply a duotune icon. The 0th path seems to
                     * be the faded element (referred to as the "secondary" path in the Font Awesome docs)
                     * of a duotone icon. 40% is the default opacity.
                     *
                     * @see https://fontawesome.com/how-to-use/on-the-web/styling/duotone-icons#changing-opacity
                     */
                    svgPathData.map((d: string, i: number) => (
                        <path
                            key={i}
                            style={{ opacity: i === 0 ? 0.4 : 1 }}
                            d={d}
                        />
                    ))
                )}
            </SvgIcon>
        );
    }
);
Icon.displayName = 'Icon';

export const NavIcons: Record<string, JSX.Element> = {
    Insights: (
        <SvgIcon
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={{ pt: 0, pb: 1, pr: 1, pl: 1 }}
        >
            <path
                d="M8.4375 0.875C9.35156 0.875 10.125 1.64844 10.125 2.5625V14.9375C10.125 15.8867 9.35156 16.625 8.4375 16.625H7.3125C6.36328 16.625 5.625 15.8867 5.625 14.9375V2.5625C5.625 1.64844 6.36328 0.875 7.3125 0.875H8.4375ZM8.4375 2.5625H7.3125V14.9375H8.4375V2.5625ZM2.8125 7.625C3.72656 7.625 4.5 8.39844 4.5 9.3125V14.9375C4.5 15.8867 3.72656 16.625 2.8125 16.625H1.6875C0.738281 16.625 0 15.8867 0 14.9375V9.3125C0 8.39844 0.738281 7.625 1.6875 7.625H2.8125ZM2.8125 9.3125H1.6875V14.9375H2.8125V9.3125ZM11.25 4.8125C11.25 3.89844 11.9883 3.125 12.9375 3.125H14.0625C14.9766 3.125 15.75 3.89844 15.75 4.8125V14.9375C15.75 15.8867 14.9766 16.625 14.0625 16.625H12.9375C11.9883 16.625 11.25 15.8867 11.25 14.9375V4.8125ZM12.9375 14.9375H14.0625V4.8125H12.9375V14.9375Z"
                fill="white"
            />
        </SvgIcon>
    ),
    Jobs: (
        <SvgIcon
            width="22"
            height="19"
            viewBox="0 0 22 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={{ pt: 0, pb: 1, pr: 1, pl: 1 }}
        >
            <path
                d="M20.9336 8.83594C21.2852 9.15234 21.3203 9.67969 21.0391 10.0312C20.7227 10.3828 20.1953 10.418 19.8438 10.1367L19 9.39844V15.9375C19 17.5195 17.7344 18.75 16.1875 18.75H6.0625C4.48047 18.75 3.25 17.5195 3.25 15.9375V9.39844L2.37109 10.1367C2.01953 10.418 1.49219 10.3828 1.17578 10.0312C0.894531 9.67969 0.929688 9.15234 1.28125 8.83594L10.5625 0.960938C10.8789 0.714844 11.3359 0.714844 11.6523 0.960938L20.9336 8.83594ZM6.0625 17.0625H9.05078L7.99609 15.375C7.85547 15.1289 7.89062 14.8125 8.13672 14.6367L11.125 12.2812L9.05078 9.60938C8.66406 9.08203 9.33203 8.41406 9.85938 8.80078L13.9023 11.8594C14.1836 12.0703 14.1836 12.4922 13.9023 12.7383L11.125 14.9531L12.4258 17.0625H16.1875C16.7852 17.0625 17.3125 16.5703 17.3125 15.9375V7.95703L11.125 2.71875L4.9375 7.95703V15.9375C4.9375 16.5703 5.42969 17.0625 6.0625 17.0625Z"
                fill="white"
            />
        </SvgIcon>
    ),
    Reviews: (
        <SvgIcon
            width="20"
            height="19"
            viewBox="0 0 20 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={{ pt: 0, pb: 1, pr: 1, pl: 1 }}
        >
            <path
                d="M10.0898 0.75C10.4414 0.75 10.7227 0.960938 10.8633 1.24219L13.2891 6.19922L18.668 7.00781C18.9844 7.04297 19.2305 7.28906 19.3359 7.57031C19.4414 7.88672 19.3711 8.20312 19.125 8.44922L15.2227 12.3164L16.1367 17.7656C16.207 18.082 16.0664 18.4336 15.8203 18.6094C15.5391 18.7852 15.1875 18.8203 14.9062 18.6797L10.0898 16.0781L5.27344 18.6797C4.99219 18.8203 4.67578 18.7852 4.39453 18.6094C4.14844 18.4336 4.00781 18.082 4.04297 17.7656L4.99219 12.3164L1.08984 8.44922C0.84375 8.20312 0.773438 7.88672 0.878906 7.57031C0.984375 7.28906 1.23047 7.04297 1.54688 7.00781L6.92578 6.19922L9.35156 1.24219C9.49219 0.960938 9.77344 0.75 10.0898 0.75ZM10.0898 3.52734L8.26172 7.35938C8.12109 7.60547 7.91016 7.78125 7.62891 7.81641L3.44531 8.41406L6.46875 11.4023C6.67969 11.6133 6.75 11.8945 6.71484 12.1758L6.01172 16.3594L9.70312 14.3906C9.94922 14.25 10.2656 14.25 10.5117 14.3906L14.2031 16.3594L13.5 12.1758C13.4297 11.8945 13.5352 11.6133 13.7461 11.4023L16.7344 8.41406L12.5859 7.81641C12.3047 7.78125 12.0586 7.60547 11.9531 7.35938L10.0898 3.52734Z"
                fill="white"
            />
        </SvgIcon>
    ),
    Media: (
        <SvgIcon
            width="23"
            height="19"
            viewBox="0 0 23 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={{ pt: 0, pb: 1, pr: 1, pl: 1 }}
        >
            <path
                d="M16.8125 16.5C16.8125 16.8164 16.5312 17.0625 16.25 17.0625H14.5625V14.25H12.875V17.0625H6.125V5.25H2.75C1.48438 5.25 0.5 6.26953 0.5 7.5V16.5C0.5 17.7656 1.48438 18.75 2.75 18.75H16.25C17.4805 18.75 18.5 17.7656 18.5 16.5V14.25H16.8125V16.5ZM4.4375 17.0625H2.75C2.43359 17.0625 2.1875 16.8164 2.1875 16.5V14.8125H4.4375V17.0625ZM4.4375 13.125H2.1875V10.875H4.4375V13.125ZM4.4375 9.1875H2.1875V7.5C2.1875 7.21875 2.43359 6.9375 2.75 6.9375H4.4375V9.1875ZM20.75 0.75H9.5C8.23438 0.75 7.25 1.76953 7.25 3V10.875C7.25 12.1406 8.23438 13.125 9.5 13.125H20.75C21.9805 13.125 23 12.1406 23 10.875V3C23 1.76953 21.9805 0.75 20.75 0.75ZM21.3125 10.875C21.3125 11.1914 21.0312 11.4375 20.75 11.4375L16.8828 5.8125C16.7773 5.63672 16.6016 5.53125 16.4258 5.53125C16.2148 5.53125 16.0391 5.63672 15.9336 5.8125L13.7539 9.11719L12.9453 8.02734C12.8398 7.88672 12.6992 7.78125 12.4883 7.78125C12.2773 7.78125 12.1367 7.88672 12.0312 8.02734L9.5 11.4375C9.18359 11.4375 8.9375 11.1914 8.9375 10.875V3C8.9375 2.71875 9.18359 2.4375 9.5 2.4375H20.75C21.0312 2.4375 21.3125 2.71875 21.3125 3V10.875ZM11.1523 3.5625C10.5195 3.5625 10.0273 4.08984 10.0273 4.6875C10.0273 5.32031 10.5195 5.8125 11.1523 5.8125C11.75 5.8125 12.2773 5.32031 12.2773 4.6875C12.2773 4.08984 11.7852 3.5625 11.1523 3.5625Z"
                fill="white"
            />
        </SvgIcon>
    ),
    Calendar: (
        <SvgIcon
            width="17"
            height="19"
            viewBox="0 0 17 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={{ pt: 0, pb: 1, pr: 1, pl: 1 }}
        >
            <path
                d="M5.84375 3H10.9062V1.59375C10.9062 1.13672 11.2578 0.75 11.75 0.75C12.207 0.75 12.5938 1.13672 12.5938 1.59375V3H14C15.2305 3 16.25 4.01953 16.25 5.25V16.5C16.25 17.7656 15.2305 18.75 14 18.75H2.75C1.48438 18.75 0.5 17.7656 0.5 16.5V5.25C0.5 4.01953 1.48438 3 2.75 3H4.15625V1.59375C4.15625 1.13672 4.50781 0.75 5 0.75C5.45703 0.75 5.84375 1.13672 5.84375 1.59375V3ZM2.1875 16.5C2.1875 16.8164 2.43359 17.0625 2.75 17.0625H14C14.2812 17.0625 14.5625 16.8164 14.5625 16.5V7.5H2.1875V16.5Z"
                fill="white"
            />
        </SvgIcon>
    ),
    CalendarAlert: (
        <SvgIcon
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={{ pt: 0, pb: 1, pr: 1, pl: 1 }}
        >
            <path
                d="M13 16.8125C13 17.4453 12.4727 17.9375 11.875 17.9375C11.2422 17.9375 10.75 17.4453 10.75 16.8125C10.75 16.2148 11.2422 15.6875 11.875 15.6875C12.4727 15.6875 13 16.2148 13 16.8125ZM12.7188 13.7188C12.7188 14.2109 12.332 14.5625 11.875 14.5625C11.3828 14.5625 11.0312 14.2109 11.0312 13.7188V11.4688C11.0312 11.0117 11.3828 10.625 11.875 10.625C12.332 10.625 12.7188 11.0117 12.7188 11.4688V13.7188ZM9.34375 5H14.4062V3.59375C14.4062 3.13672 14.7578 2.75 15.25 2.75C15.707 2.75 16.0938 3.13672 16.0938 3.59375V5H17.5C18.7305 5 19.75 6.01953 19.75 7.25V18.5C19.75 19.7656 18.7305 20.75 17.5 20.75H6.25C4.98438 20.75 4 19.7656 4 18.5V7.25C4 6.01953 4.98438 5 6.25 5H7.65625V3.59375C7.65625 3.13672 8.00781 2.75 8.5 2.75C8.95703 2.75 9.34375 3.13672 9.34375 3.59375V5ZM5.6875 18.5C5.6875 18.8164 5.93359 19.0625 6.25 19.0625H17.5C17.7812 19.0625 18.0625 18.8164 18.0625 18.5V9.5H5.6875V18.5Z"
                fill="#FF5D51"
            />
        </SvgIcon>
    ),
    Settings: (
        <SvgIcon
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={{ p: 1 }}
        >
            <path
                d="M6.125 9.75C6.125 7.88672 7.60156 6.375 9.5 6.375C11.3633 6.375 12.875 7.88672 12.875 9.75C12.875 11.6133 11.3633 13.125 9.5 13.125C7.60156 13.125 6.125 11.6133 6.125 9.75ZM9.5 8.0625C8.55078 8.0625 7.8125 8.83594 7.8125 9.75C7.8125 10.6992 8.55078 11.4375 9.5 11.4375C10.4141 11.4375 11.1875 10.6992 11.1875 9.75C11.1875 8.83594 10.4141 8.0625 9.5 8.0625ZM10.8008 0.75C11.5742 0.75 12.2422 1.3125 12.418 2.05078L12.6992 3.21094C13.0156 3.35156 13.2969 3.52734 13.543 3.70312L14.7031 3.35156C15.4414 3.14062 16.25 3.45703 16.6367 4.125L17.9375 6.41016C18.3242 7.07812 18.1836 7.92188 17.6211 8.44922L16.7773 9.25781C16.7773 9.43359 16.8125 9.60938 16.8125 9.75C16.8125 9.92578 16.7773 10.1016 16.7773 10.2422L17.6211 11.0859C18.1836 11.6133 18.3242 12.457 17.9375 13.125L16.6367 15.4102C16.25 16.0781 15.4414 16.3945 14.7031 16.1836L13.543 15.832C13.2969 16.0078 13.0156 16.1836 12.6992 16.3242L12.418 17.4844C12.2422 18.2227 11.5742 18.75 10.8008 18.75H8.16406C7.39062 18.75 6.72266 18.2227 6.54688 17.4844L6.26562 16.3242C5.94922 16.1836 5.66797 16.0078 5.42188 15.832L4.26172 16.1836C3.52344 16.3945 2.71484 16.0781 2.32812 15.4102L1.02734 13.125C0.640625 12.457 0.78125 11.6133 1.34375 11.0859L2.1875 10.2422C2.1875 10.1016 2.1875 9.92578 2.1875 9.75C2.1875 9.60938 2.1875 9.43359 2.1875 9.25781L1.34375 8.44922C0.78125 7.92188 0.640625 7.07812 1.02734 6.41016L2.32812 4.125C2.71484 3.45703 3.52344 3.14062 4.26172 3.35156L5.42188 3.70312C5.66797 3.52734 5.94922 3.35156 6.26562 3.21094L6.54688 2.05078C6.72266 1.3125 7.39062 0.75 8.16406 0.75H10.8008ZM7.70703 4.40625L7.32031 4.58203C6.86328 4.75781 6.44141 5.00391 6.08984 5.28516L5.73828 5.56641L3.80469 4.96875L2.50391 7.25391L3.94531 8.625L3.91016 9.04688C3.875 9.29297 3.875 9.53906 3.875 9.75C3.875 9.99609 3.875 10.2422 3.91016 10.4883L3.94531 10.9102L2.50391 12.2812L3.80469 14.5664L5.73828 13.9688L6.08984 14.25C6.44141 14.5312 6.86328 14.7773 7.32031 14.9531L7.70703 15.1289L8.16406 17.0625H10.8008L11.2578 15.1289L11.6445 14.9531C12.1016 14.7773 12.5234 14.5312 12.875 14.25L13.2266 13.9688L15.1602 14.5664L16.4609 12.2812L15.0195 10.9102L15.0547 10.4883C15.0898 10.2422 15.125 9.99609 15.125 9.75C15.125 9.53906 15.0898 9.29297 15.0547 9.04688L15.0195 8.625L16.4609 7.25391L15.1602 4.96875L13.2266 5.56641L12.875 5.28516C12.5234 5.00391 12.1016 4.75781 11.6445 4.58203L11.2578 4.40625L10.8008 2.4375H8.16406L7.70703 4.40625Z"
                fill="white"
            />
        </SvgIcon>
    ),
};

export const BackArrow = ({ sx, ...rest }: { sx?: SxProps }): JSX.Element => (
    <SvgIcon
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        sx={sx}
        {...rest}
    >
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21.207 12.25C21.207 12.8516 20.7344 13.3242 20.1758 13.3242H5.56641L11.2812 18.7383C11.7109 19.125 11.7109 19.8125 11.3242 20.1992C10.9375 20.6289 10.293 20.6289 9.86328 20.2422L2.30078 13.0234C2.08594 12.8086 2 12.5508 2 12.25C2 11.9922 2.08594 11.7344 2.30078 11.5195L9.86328 4.30078C10.293 3.91406 10.9375 3.91406 11.3242 4.34375C11.7109 4.73047 11.7109 5.41797 11.2812 5.80469L5.56641 11.2188H20.1758C20.7773 11.2188 21.207 11.6914 21.207 12.25Z"
                fill="#202126"
            />
        </svg>
    </SvgIcon>
);

export const GoogleIcon = forwardRef<
    SVGSVGElement,
    {
        fillColor?: string;
        sx?: SxProps<Theme>;
    }
>(({ sx, fillColor, ...rest }, ref): JSX.Element => {
    return (
        <SvgIcon
            ref={ref}
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={[
                fillColor
                    ? {
                          '& > path': {
                              fill: fillColor,
                          },
                      }
                    : {},
                ...(Array.isArray(sx) ? sx : [{ ...sx }]),
            ]}
            {...rest}
        >
            <path
                d="M18 9.21583C18 8.608 17.94 7.98056 17.84 7.39233H9.17755V10.8629H14.1389C13.9389 11.9805 13.2787 12.9609 12.2984 13.5883L15.2592 15.8432C16.9997 14.2549 18 11.9413 18 9.21583Z"
                fill="#4280EF"
            />
            <path
                d="M9.17754 17.9999C11.6582 17.9999 13.7388 17.196 15.2592 15.8235L12.2984 13.5882C11.4782 14.1372 10.4179 14.4509 9.17754 14.4509C6.77688 14.4509 4.75632 12.8627 4.01611 10.7451L0.975266 13.0392C2.5357 16.0783 5.69658 17.9999 9.17754 17.9999Z"
                fill="#34A353"
            />
            <path
                d="M4.01611 10.7255C3.63601 9.60791 3.63601 8.39224 4.01611 7.27462L0.975271 4.96094C-0.32509 7.50991 -0.32509 10.5099 0.975271 13.0392L4.01611 10.7255Z"
                fill="#F6B704"
            />
            <path
                d="M9.17754 3.5689C10.4779 3.54929 11.7583 4.03948 12.6985 4.92182L15.3193 2.33363C13.6588 0.804248 11.4582 -0.0192653 9.17754 0.000342207C5.69658 0.000342207 2.5357 1.92187 0.975266 4.96103L4.01611 7.27471C4.75632 5.1375 6.77688 3.5689 9.17754 3.5689Z"
                fill="#E54335"
            />
        </SvgIcon>
    );
});

export const ZapierIcon = forwardRef<
    SVGSVGElement,
    {
        fillColor?: string;
        sx?: SxProps<Theme>;
    }
>(({ sx, fillColor, ...rest }, ref): JSX.Element => {
    return (
        <SvgIcon
            ref={ref}
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={[
                fillColor
                    ? {
                          '& > path': {
                              fill: fillColor,
                          },
                      }
                    : {},
                ...(Array.isArray(sx) ? sx : [{ ...sx }]),
            ]}
            {...rest}
        >
            <rect y="0.524658" width="24" height="24" rx="4" fill="#FF4F00" />
            <path
                d="M16.7337 14.4817C17.0386 14.6528 17.3842 14.7379 17.7336 14.7281C18.0182 14.7373 18.302 14.6914 18.5692 14.5928C18.7707 14.5201 18.9503 14.3971 19.0909 14.2354C19.2234 14.08 19.3192 13.8968 19.371 13.6993L18.4581 13.4433C18.4139 13.5701 18.3333 13.681 18.2263 13.762C18.0869 13.864 17.9153 13.912 17.7433 13.8973C17.6221 13.9067 17.5005 13.8875 17.3881 13.8414C17.2757 13.7952 17.1756 13.7234 17.096 13.6316C16.9678 13.4415 16.8974 13.2184 16.8931 12.9892H19.3903C19.3945 12.9168 19.3945 12.8443 19.3903 12.7719V12.5787C19.3956 12.2725 19.3329 11.969 19.2068 11.6899C19.0844 11.4376 18.8914 11.2261 18.6513 11.0813C18.3637 10.9271 18.0404 10.852 17.7143 10.864C17.4618 10.8469 17.2086 10.8809 16.9696 10.9639C16.7306 11.0469 16.5107 11.1772 16.3232 11.347C15.9836 11.7299 15.8099 12.232 15.8402 12.7429C15.8326 13.1021 15.9104 13.458 16.0672 13.7814C16.2125 14.0775 16.4452 14.3219 16.7337 14.4817ZM17.6998 11.6609C18.1828 11.6609 18.405 11.9218 18.4388 12.4482H16.8931C16.9075 12.2605 16.9726 12.0802 17.0815 11.9266C17.1588 11.8354 17.2575 11.7647 17.3687 11.7209C17.48 11.677 17.6003 11.6614 17.7191 11.6754L17.6998 11.6609Z"
                fill="#FFFDF9"
            />
            <path
                d="M7.42516 12.5507C7.05136 12.516 6.67836 12.6248 6.38186 12.855C6.2761 12.9573 6.19306 13.0807 6.13814 13.2172C6.08321 13.3537 6.05762 13.5002 6.06305 13.6472C6.05159 13.7972 6.07533 13.9478 6.13236 14.087C6.18938 14.2262 6.2781 14.3501 6.3915 14.449C6.63974 14.636 6.94571 14.73 7.25611 14.7147C7.4114 14.7194 7.56592 14.6909 7.70923 14.6309C7.85255 14.5709 7.98131 14.4809 8.08689 14.3669C8.20262 14.2377 8.29424 14.0889 8.35737 13.9273H8.42017L8.53128 14.6374H9.42485V12.3624C9.45107 11.9658 9.31906 11.575 9.05775 11.2756C8.89241 11.1339 8.70039 11.0267 8.49302 10.9604C8.28564 10.894 8.06709 10.8698 7.85021 10.8892C7.57081 10.8817 7.29243 10.9259 7.02908 11.0196C6.82081 11.0941 6.63703 11.2244 6.49777 11.3963C6.36687 11.5605 6.27888 11.7548 6.24176 11.9615L7.23197 12.1015C7.26629 11.9985 7.33434 11.91 7.42516 11.8504C7.54009 11.7866 7.67067 11.7565 7.80192 11.7634C7.88196 11.7565 7.96257 11.7666 8.03836 11.7933C8.11415 11.82 8.18339 11.8625 8.24145 11.918C8.33754 12.0492 8.38534 12.2096 8.37671 12.372V12.5507H7.42516ZM7.60387 13.8645C7.46105 13.8789 7.31806 13.8392 7.20299 13.7534C7.1665 13.7157 7.13789 13.671 7.11882 13.6221C7.09975 13.5732 7.09058 13.521 7.09187 13.4685C7.09078 13.4174 7.10008 13.3667 7.11917 13.3194C7.13827 13.2721 7.16679 13.2291 7.20299 13.1931C7.29122 13.1212 7.40326 13.085 7.51693 13.0917H8.37671V13.2318C8.37824 13.3187 8.35986 13.4047 8.32303 13.4834C8.28619 13.5621 8.23187 13.6314 8.16419 13.6858C8.00571 13.8127 7.80667 13.8779 7.60387 13.8694V13.8645Z"
                fill="#FFFDF9"
            />
            <path
                d="M15.3135 10.9752H14.2557V14.6365H15.3135V10.9752Z"
                fill="#FFFDF9"
            />
            <path
                d="M14.7972 10.483C14.8765 10.4856 14.9556 10.4719 15.0295 10.4428C15.1034 10.4137 15.1706 10.3699 15.2271 10.314C15.3367 10.1962 15.3957 10.0401 15.3913 9.87927C15.3954 9.71992 15.3364 9.56538 15.2271 9.44938C15.1702 9.39434 15.1028 9.35142 15.0289 9.32319C14.9551 9.29496 14.8762 9.28202 14.7972 9.28516C14.7174 9.28192 14.6378 9.29479 14.5631 9.32301C14.4884 9.35123 14.4202 9.3942 14.3625 9.44938C14.3066 9.50579 14.2627 9.57301 14.2337 9.64692C14.2046 9.72083 14.1909 9.79989 14.1934 9.87927C14.19 9.95947 14.2033 10.0395 14.2324 10.1143C14.2615 10.1891 14.3059 10.257 14.3626 10.3138C14.4194 10.3706 14.4873 10.4149 14.5621 10.4441C14.6369 10.4732 14.717 10.4865 14.7972 10.483Z"
                fill="#FFFDF9"
            />
            <path
                d="M11.1264 13.9222H11.1747C11.2049 14.0026 11.242 14.0802 11.2857 14.1541C11.3947 14.3538 11.5637 14.5143 11.7688 14.6129C11.9482 14.7042 12.1471 14.7506 12.3484 14.7482C12.547 14.7567 12.7444 14.7135 12.9213 14.6229C13.0982 14.5323 13.2487 14.3974 13.3579 14.2314C13.6205 13.7955 13.7451 13.2903 13.7153 12.7823C13.7417 12.289 13.6188 11.7992 13.3627 11.3767C13.244 11.2156 13.0867 11.0869 12.9052 11.0025C12.7237 10.918 12.524 10.8807 12.3242 10.8937C12.1671 10.8881 12.0106 10.9158 11.865 10.9749C11.7193 11.034 11.5877 11.1232 11.479 11.2367C11.3304 11.3976 11.2184 11.5887 11.1505 11.797H11.0926L10.9766 10.9903H10.0734V15.7046H11.1312L11.1264 13.9222ZM11.8992 11.8259C12.0102 11.8163 12.1219 11.8347 12.224 11.8795C12.3261 11.9242 12.4154 11.9938 12.4836 12.0819C12.6164 12.2941 12.6805 12.542 12.6672 12.792C12.6825 13.0519 12.6167 13.3101 12.4788 13.531C12.4133 13.6215 12.3255 13.6936 12.224 13.7401C12.1224 13.7867 12.0105 13.8061 11.8992 13.7966C11.7913 13.8026 11.6836 13.7824 11.5853 13.7378C11.4869 13.6933 11.4007 13.6256 11.3341 13.5406C11.185 13.335 11.1117 13.0841 11.1264 12.8306V12.763C11.1083 12.5136 11.1822 12.2661 11.3341 12.0674C11.4037 11.9869 11.4908 11.9232 11.5887 11.8814C11.6866 11.8395 11.7928 11.8206 11.8992 11.8259Z"
                fill="#FFFDF9"
            />
            <path
                d="M5.73759 13.7429H3.76688L3.73309 13.6318L5.70378 11.8736V10.9752H2.44342V11.8736H4.28854L4.33203 11.9896L2.39996 13.7429V14.6413H5.78108L5.73759 13.7429Z"
                fill="#FFFDF9"
            />
            <path
                d="M21.0142 12.763C20.9973 12.6584 21.0064 12.5513 21.0406 12.451C21.0747 12.3508 21.133 12.2604 21.2103 12.1879C21.2875 12.1155 21.3814 12.063 21.4836 12.0353C21.5859 12.0075 21.6934 12.0053 21.7966 12.0288H22.1976V10.9758H21.9657C21.8314 10.9698 21.6975 10.9955 21.575 11.0509C21.4524 11.1062 21.3447 11.1898 21.2605 11.2946C21.1518 11.4386 21.0729 11.6028 21.0286 11.7776H20.9755L20.8596 10.971H19.9564V14.6371H21.0142V12.763Z"
                fill="#FFFDF9"
            />
        </SvgIcon>
    );
});

export const JobNimbusIcon = forwardRef<
    SVGSVGElement,
    {
        fillColor?: string;
        sx?: SxProps<Theme>;
    }
>(({ sx, fillColor, ...rest }, ref): JSX.Element => {
    return (
        <SvgIcon
            ref={ref}
            width="24"
            height="12"
            viewBox="0 0 24 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={[
                fillColor
                    ? {
                          '& > path': {
                              fill: fillColor,
                          },
                      }
                    : {},
                ...(Array.isArray(sx) ? sx : [{ ...sx }]),
            ]}
            {...rest}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.4462 0H0V11.4462C6.32131 11.4456 11.4456 6.32131 11.4462 0Z"
                fill="#3B5EAB"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.5538 0V11.4462H24C23.9995 5.12484 18.8752 0.000546296 12.5538 0Z"
                fill="#3B5EAB"
            />
        </SvgIcon>
    );
});

export const HousecallProIcon = forwardRef<
    SVGSVGElement,
    {
        fillColor?: string;
        sx?: SxProps<Theme>;
    }
>(({ sx, fillColor, ...rest }, ref): JSX.Element => {
    return (
        <SvgIcon
            ref={ref}
            width="13"
            height="24"
            viewBox="0 0 13 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={[
                fillColor
                    ? {
                          '& > path': {
                              fill: fillColor,
                          },
                      }
                    : {},
                ...(Array.isArray(sx) ? sx : [{ ...sx }]),
            ]}
            {...rest}
        >
            <path
                d="M0 4.45328V19.9385L7.55572 24V0L0 4.45328ZM12.9231 21.7621H9.73958V19.961H11.1265L11.176 4.40826H9.73958V2.60713H12.9861L12.9231 21.7621Z"
                fill="black"
            />
        </SvgIcon>
    );
});
